import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Plans from "./components/Plans";
import Email from "./components/Email";
import Contact from "./components/Contact";
import P404 from "./components/P404";
import Story1 from './components/Story1'
import Story2 from './components/Story2'
import Story3 from './components/Story3'
import Reiki from "./components/Reiki";
import Terms from "./components/Terms";
import Privacy from './components/Privacy';
import Admins from "./admin/Admins";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

const App = () => {
  return (
    <div className="app">
      <BrowserRouter>
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/plans" component={Plans} />
          <Route exact path="/email" component={Email} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/reiki" component={Reiki} />
          <Route exact path="/reiki/story1" component={Story1} />
          <Route exact path="/reiki/story2" component={Story2} />
          <Route exact path="/reiki/story3" component={Story3} />
          <Route exact path="/p404" component={P404} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/policy" component={Privacy} />
          <Route exact path="/admin" component={Admins} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
